/* eslint-disable import/no-unresolved */
import {
  DEFAULT_SIGN_HEADER,
  DEFAULT_SIGN_API_PATH,
  encryptToken,
} from '@xhs/fe-api-sign'
import { info } from '@xhs/logger'

// 验签不通过的错误码
const SPAM_CODE = 406
// 签名错误：此时接口报错406，但是错误码为 1
const SIGN_FAIL_ERROR = '1'
// 服务器时间与传过去的 timestamp 相差过大
const TIME_ERROR_CODE = '2'
// 验签失败（对于刚接入的页面可能存在），为了不影响业务，对 API 签名采取渐进式，一开始不会直接 406，而是返回 200，通过 header 中的字段来进行判断
const SIGN_FAIL_CODE = '3'
// 字体匹错误，此时状态是验签通过，字体错误，依旧返回 406
const FONT_FAIL_CODE = '4'
// 最多刷新五次
const RELOAD_COUNT = 5

function getStorageItem(item) {
  // 获取设置的计数器count，此处获取的为String，如果不存在则返回null
  const itemCount = parseInt(window.sessionStorage.getItem(item) || 0, 10) + 1
  // setItem的值
  window.sessionStorage.setItem(item, itemCount.toString())
  // logger 错误信息打点
  info(item, { arg1: itemCount }, item)
  // return reload 状态
  return itemCount < RELOAD_COUNT
}

function spamNeedReload(kongHeader) {
  let reloadStatus = false
  if (!window.spamTimer) {
    // 一小时清除一次缓存
    window.spamTimer = window.setTimeout(() => {
      window.sessionStorage.removeItem('spam_font_counter')
      window.sessionStorage.removeItem('spam_sign_counter')
    }, 3600000)
  }
  if (kongHeader === SIGN_FAIL_CODE || kongHeader === SIGN_FAIL_ERROR) {
    reloadStatus = getStorageItem('spam_sign_counter')
  }
  if (kongHeader === FONT_FAIL_CODE) {
    reloadStatus = getStorageItem('spam_font_counter')
  }
  return reloadStatus
}

export default {
  name: 'crawler-spam',
  installed: false,
  install(app, Launcher) {
    // Server side do not need it 2018年11月23日17:53:37
    if (this.installed || !Launcher.isBrowser) {
      return
    }

    Launcher.http.interceptors.dispatch.use(requestConfig => {
      if (requestConfig.url.indexOf(DEFAULT_SIGN_API_PATH) > -1) {
        requestConfig.headers[DEFAULT_SIGN_HEADER] = encryptToken(requestConfig, Launcher.http.buildURL) // eslint-disable-line max-len
      }
      // 判断是否需要新版 sign
      let { url = '' } = requestConfig

      // @ts-ignore
      if (window?.shouldSign && window.shouldSign(url)) {
        let uri = url

        if (url.indexOf('//') === 0) {
          url = `${window.location.protocol}${url}`
        }
        // uri 需要拿 path，而不是整个 url
        if (/^https?:/.test(url)) {
          try {
            const urlObj = new URL(url)

            uri = urlObj.href.replace(urlObj.origin, '')
          } catch (e) {
            uri = url
          }
        }
        const { params, paramsSerializer } = requestConfig
        // @ts-ignore
        const realUrl = Launcher.http.buildURL(uri, params, paramsSerializer)
        // 直接吐出 header
        // @ts-ignore
        const newHeaders = window.sign(realUrl, requestConfig.data) || {}
        // 新增全局的FontId
        const newHeadersFontId = window.f && typeof window.f === 'function' ? window.f() : {}

        requestConfig.headers = {
          ...requestConfig.headers,
          ...newHeaders,
          ...newHeadersFontId,
        }
      }

      return requestConfig
    })
    // @ts-ignore
    Launcher.http.interceptors.spam.use(response => {
      const kongHeader = response?.headers && response.headers['x-kong-sign']
      // 判断response状态码 = 406，且TIME_ERROR_CODE = 2只在 406时候出现
      if (response.status === SPAM_CODE) { // 406
        if (kongHeader && kongHeader === TIME_ERROR_CODE) {
          alert('系统时间错误') // eslint-disable-line no-alert
          info('systemTimeError', undefined, 'system_time_error')
        } else if (spamNeedReload(kongHeader)) {
          window.location.reload()
        }
      } else if (kongHeader && spamNeedReload(kongHeader)) {
        window.location.reload()
      }
      return response
    })
    this.installed = true
  },
}
